module.exports = __webpack_public_path__ + "ni.svg?7affd52e71f565734b35c729fd9a69c6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ni.svg
// module id = 1283
// module chunks = 0